import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	initData: null,
};

export const GlobalSlice = createSlice({
	name: "globalSlice",
	initialState,
	reducers: {
		setInitData: (state, action) => {
			state.initData = action.payload;
		},
		clearGlobalData: () => {
			return initialState;
		},
	},
});

// Action creators are generated for each case reducer function
export const { clearGlobalData, setInitData } = GlobalSlice.actions;

export default GlobalSlice.reducer;
